
import { extendTheme } from '@chakra-ui/react'
const theme = {
    fonts: {
        heading: `'Roboto', 'Noto Serif JP', serif`,
        body: `'Roboto', 'Noto Serif JP', serif`,
    }
}

export default extendTheme(theme)